import React, { useState, useEffect, useRef } from 'react';
import './GallerySection.css';

const GallerySection = () => {
  const [loadedImages, setLoadedImages] = useState(new Set());
  const imageRefs = useRef([]);

  useEffect(() => {
    // Preload hero background image
    const heroImg = new Image();
    heroImg.src = '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__24137.webp';
    
    // Intersection Observer for lazy loading gallery images
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const imgSrc = entry.target.dataset.src;
            if (imgSrc && !loadedImages.has(imgSrc)) {
              const img = new Image();
              img.src = imgSrc;
              img.onload = () => {
                setLoadedImages((prev) => new Set([...prev, imgSrc]));
                entry.target.style.backgroundImage = `url(${imgSrc})`;
                entry.target.classList.add('loaded');
              };
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: '50px' }
    );

    imageRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      imageRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, [loadedImages]);
  const galleryItems = [
    {
      id: 1,
      title: 'Welcome Baby',
      category: 'Baby Shower',
      image: '/images/BabyShower/freepik__the-style-is-candid-image-photography-with-natural__416.webp',
      description: 'Elegant baby shower setup'
    },
    {
      id: 2,
      title: 'Romantic Celebration',
      category: 'Anniversary',
      image: '/images/AnniversaryImages/freepik__35mm-film-photography-ultraluxury-romantic-anniver__411.webp',
      description: 'Romantic anniversary celebration'
    },
    {
      id: 3,
      title: "Kid's Birthday",
      category: "Kid's Birthday",
      image: '/images/KidBirthdayDecorations/WhatsApp%20Image%202026-04-10%20at%208.07.12%20PM.jpeg',
      description: 'Kids birthday party decoration'
    },
    {
      id: 4,
      title: 'Premium Birthday',
      category: 'Birthday',
      image: '/images/BirthdayImages/freepik__35mm-film-photography-premium-birthday-decoration-__13643.webp',
      description: 'Elegant birthday decoration'
    },
    {
      id: 5,
      title: '25th Anniversary',
      category: 'Anniversary',
      image: '/images/AnniversaryImages/freepik__35mm-film-photography-luxury-25th-anniversary-setu__414.webp',
      description: 'Golden anniversary celebration'
    },
    {
      id: 6,
      title: 'Luxury Balloons',
      category: 'Birthday',
      image: '/images/BirthdayImages/freepik__grand-luxury-balloon-installation-oversized-organi__3947.webp',
      description: 'Luxury balloon celebration'
    }
  ];

  return (
    <section id="gallery" className="gallery-section">
      <div 
        className="gallery-hero"
        style={{
          backgroundImage: `url('/images/banners/freepik__the-style-is-candid-image-photography-with-natural__66015.webp')`
        }}
      >
        <div className="gallery-hero-overlay"></div>
        <div className="gallery-hero-content">
          <h2 className="gallery-hero-text">Kids Birthday Party Activities</h2>
          <h3 className="gallery-hero-subtext">Magic show, Game coordinator, Tattoo, Slime Making, Stone making, Science Show & Many more</h3>
        </div>
      </div>
      
      <div className="gallery-container">
        <div className="gallery-header">
          <h2 className="gallery-title">Our Recent Work</h2>
          <p className="gallery-subtitle">Transforming celebrations into unforgettable memories</p>
        </div>
        
        <div className="gallery-grid">
          {galleryItems.map((item, index) => (
            <div 
              key={item.id} 
              className="gallery-item"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="gallery-image-wrapper">
                <div 
                  ref={(el) => (imageRefs.current[index] = el)}
                  className="gallery-image"
                  data-src={item.image}
                  style={loadedImages.has(item.image) ? { backgroundImage: `url(${item.image})` } : {}}
                >
                  <div className="gallery-overlay">
                    <div className="gallery-info">
                      <span className="gallery-category">{item.category}</span>
                      <h3 className="gallery-item-title">{item.title}</h3>
                      <p className="gallery-item-description">{item.description}</p>
                      <a 
                        href="https://wa.me/919910980273" 
                        className="gallery-cta-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Get Quote
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
